import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import App from "app";
import store from "app/store";
import config from "config";
import { BeaconCommand } from "utils/helpers";

// global typescript defs
declare global {
    interface Window {
        Beacon: any; // helpscout
        ReactNativeWebView?: any; // mobile app webview
    }
}

// root component
const root = (
    // TODO(deermichel): reenable strict mode as soon as material-ui supports it
    // https://github.com/mui-org/material-ui/issues/13394
    // <React.StrictMode>
    <Provider store={store}>
        <App />
    </Provider>
    // </React.StrictMode>
);

// render
ReactDOM.render(root, document.getElementById("root"));

window.Beacon(BeaconCommand.INIT, config.helpscout.beaconId);
